<template>
<drag-zone :class="$style['vertical-zone']" style="height:100%;width:100%;" :options="{ direction: 'vertical' }">
  <drag-content :class="[$style['vertical-zone--content'], $style['vertical-zone--content-top']]">
    <slot name="topContent" />
  </drag-content>
  <!-- Splitter -->
  <drag-handle :class="$style['vertical-zone--handle']">
    <div class="fa fa-ellipsis-h" style="color: #b4b4b4;"></div>
  </drag-handle>
  <drag-content :class="[$style['vertical-zone--content'], $style['vertical-zone--content-bottom']]">
    <slot name="bottomContent" />
  </drag-content>
</drag-zone>
</template>

<script>
import DragZone from '@/components/external/VueDragZone/zone';
import DragHandle from '@/components/external/VueDragZone/handle';
import DragContent from '@/components/external/VueDragZone/content';

export default {
  name: 'WTreeSplitterContainer',
  components: {
    DragZone,
    DragHandle,
    DragContent,
  },
};
</script>

<style module>
.vertical-zone {
  width: 100%;
  height: 100%;
  /* margin: 0; */
  position: relative;
  clear: both;
  /* text-align: center; */
  color: white;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.vertical-zone--handle {
  /* width: 100%; */
  height: 10px;
  border-top: 1px solid #efe8e8;
  /* border-bottom: 1px solid #efe8e8; */
  /* background: #f6f6f6; */
  outline: 0;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -20px;
}

.vertical-zone--content {
  display: flex;
  width: 100%;
  overflow: auto;
}

.vertical-zone--content-top {
  height: 60%;
  min-height: 200px;
}

.vertical-zone--content-bottom {
  height: 40%;
  min-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/template/TreeSplitterTemplate.vue